module.exports = __webpack_public_path__ + "img/error-dark.dee1eb51.svg";